import * as yup from 'yup';

export const schema = yup.object({
  des_grade: yup.string().required().max(50),
});
